import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withKeys as _withKeys, normalizeStyle as _normalizeStyle, vShow as _vShow, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dbecb4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-cl-title" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-tagwin-title" }, "Success!", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-tagwin-sub" }, "You solved the tagged tangle!", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-tabsettings-title" }, "Tabs on this panel", -1 /* HOISTED */))
const _hoisted_7 = ["checked", "onChange"]
const _hoisted_8 = { class: "nge-cl-filters" }
const _hoisted_9 = {
  key: 1,
  class: "nge-cl-search"
}
const _hoisted_10 = {
  key: 2,
  class: "nge-cl-search"
}
const _hoisted_11 = {
  key: 3,
  class: "nge-cl-list"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-help-open-plus" }, "+", -1 /* HOISTED */))
const _hoisted_13 = {
  key: 1,
  class: "nge-cl-help-quickadd"
}
const _hoisted_14 = { class: "nge-cl-help-quickadd-row" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "No annotation layer", -1 /* HOISTED */))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "nge-cl-help-quickadd-row" }
const _hoisted_19 = ["onKeydown"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 8h3l2-2.5h8L18 8h3v11H3z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13.5",
    r: "3.8"
  })
], -1 /* HOISTED */))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "nge-cl-help-shot-preview nge-cl-help-shot-preview--sm"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 1,
  class: "nge-cl-help-create-err"
}
const _hoisted_25 = {
  key: 2,
  class: "nge-cl-empty"
}
const _hoisted_26 = {
  key: 3,
  class: "nge-cl-no-results"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "nge-cl-help-ds-name" }
const _hoisted_29 = {
  key: 0,
  class: "nge-cl-help-ds-tag nge-cl-help-ds-tag--current"
}
const _hoisted_30 = {
  key: 1,
  class: "nge-cl-help-ds-tag nge-cl-help-ds-tag--other"
}
const _hoisted_31 = { class: "nge-cl-help-ds-count" }
const _hoisted_32 = { class: "nge-cl-row" }
const _hoisted_33 = { class: "nge-cl-row-left" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-pip nge-cl-status--help" }, null, -1 /* HOISTED */))
const _hoisted_35 = { class: "nge-cl-row-info" }
const _hoisted_36 = ["onClick", "title"]
const _hoisted_37 = {
  key: 0,
  class: "nge-cl-copied"
}
const _hoisted_38 = { class: "nge-cl-row-meta" }
const _hoisted_39 = { class: "nge-cl-badge nge-cl-status--help" }
const _hoisted_40 = {
  key: 0,
  class: "nge-cl-notes"
}
const _hoisted_41 = { class: "nge-cl-notes" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "nge-cl-row-actions" }
const _hoisted_46 = ["onClick", "title"]
const _hoisted_47 = ["onClick", "title"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "nge-cl-response-display"
}
const _hoisted_50 = { class: "nge-cl-response-label" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 0,
  class: "nge-cl-response-text"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 2,
  class: "nge-cl-response-layer"
}
const _hoisted_55 = ["href"]
const _hoisted_56 = ["src"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 1,
  class: "nge-cl-response-form"
}
const _hoisted_59 = ["onKeydown"]
const _hoisted_60 = { class: "nge-cl-response-url-row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select annotation layer (optional)", -1 /* HOISTED */))
const _hoisted_62 = ["value"]
const _hoisted_63 = {
  key: 2,
  class: "nge-cl-help-shot-preview"
}
const _hoisted_64 = ["src"]
const _hoisted_65 = ["disabled", "onClick"]
const _hoisted_66 = ["disabled", "onClick"]
const _hoisted_67 = { class: "nge-cl-row nge-cl-row--done" }
const _hoisted_68 = { class: "nge-cl-row-left" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-pip",
  style: {"background":"#556"}
}, null, -1 /* HOISTED */))
const _hoisted_70 = { class: "nge-cl-row-info" }
const _hoisted_71 = ["onClick", "title"]
const _hoisted_72 = { class: "nge-cl-row-meta" }
const _hoisted_73 = {
  class: "nge-cl-badge",
  style: {"background":"rgba(85,102,119,0.15)","color":"#889"}
}
const _hoisted_74 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_75 = { class: "nge-cl-notes" }
const _hoisted_76 = { class: "nge-cl-row-actions" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 0,
  class: "nge-cl-response-display"
}
const _hoisted_80 = { class: "nge-cl-response-label" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 0,
  class: "nge-cl-response-text"
}
const _hoisted_83 = ["onClick"]
const _hoisted_84 = {
  key: 2,
  class: "nge-cl-response-layer"
}
const _hoisted_85 = ["href"]
const _hoisted_86 = ["src"]
const _hoisted_87 = { class: "nge-cl-quest" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-quest-title" }, "Learn more at connectome.quest", -1 /* HOISTED */))
const _hoisted_89 = { class: "nge-cl-quest-grid" }
const _hoisted_90 = ["href", "title"]
const _hoisted_91 = { class: "nge-cl-quest-icon" }
const _hoisted_92 = { class: "nge-cl-quest-label" }
const _hoisted_93 = { class: "nge-cl-list" }
const _hoisted_94 = {
  class: "nge-cl-quest",
  style: {"margin-top":"0"}
}
const _hoisted_95 = { class: "nge-cl-quest-title" }
const _hoisted_96 = ["innerHTML"]
const _hoisted_97 = { class: "nge-cl-tags-hint" }
const _hoisted_98 = ["innerHTML"]
const _hoisted_99 = { class: "nge-cl-tags-lanes" }
const _hoisted_100 = ["src"]
const _hoisted_101 = ["src"]
const _hoisted_102 = ["title"]
const _hoisted_103 = {
  key: 0,
  class: "nge-cl-tags-hint",
  style: {"padding":"10px 4px"}
}
const _hoisted_104 = { class: "nge-cl-row" }
const _hoisted_105 = { class: "nge-cl-row-left" }
const _hoisted_106 = { class: "nge-cl-row-info" }
const _hoisted_107 = { class: "nge-cl-row-name" }
const _hoisted_108 = {
  key: 0,
  class: "nge-cl-notes"
}
const _hoisted_109 = { class: "nge-cl-row-meta" }
const _hoisted_110 = { class: "nge-cl-notes" }
const _hoisted_111 = {
  key: 0,
  class: "nge-cl-badge",
  style: {"background":"rgba(245,209,66,0.12)","color":"#f5d142"}
}
const _hoisted_112 = { class: "nge-cl-notes" }
const _hoisted_113 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"margin-top":"2px"}
}
const _hoisted_114 = {
  key: 1,
  class: "nge-cl-notes",
  style: {"margin-top":"2px"}
}
const _hoisted_115 = ["href"]
const _hoisted_116 = ["src"]
const _hoisted_117 = { class: "nge-cl-row-actions" }
const _hoisted_118 = { class: "nge-orbit-wrap" }
const _hoisted_119 = {
  key: 0,
  class: "nge-orbit-dot",
  "aria-hidden": "true"
}
const _hoisted_120 = ["onClick", "disabled", "title"]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { class: "nge-cl-row nge-cl-row--done" }
const _hoisted_125 = { class: "nge-cl-row-left" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-pip",
  style: {"background":"#556"}
}, null, -1 /* HOISTED */))
const _hoisted_127 = { class: "nge-cl-row-info" }
const _hoisted_128 = { class: "nge-cl-row-name" }
const _hoisted_129 = { class: "nge-cl-row-meta" }
const _hoisted_130 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_131 = { class: "nge-cl-notes" }
const _hoisted_132 = { class: "nge-cl-row-actions" }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = ["onClick"]
const _hoisted_135 = { class: "nge-cl-list" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-cl-quest",
  style: {"margin-top":"0"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-quest-title" }, "🤖 AI-predicted reconstruction errors"),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-credit" }, "from the Dorkenwald and Fuming model"),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-scale" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-ai-dot nge-cl-ai-dot--cool" }),
    /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-scale-bar" }),
    /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-ai-dot nge-cl-ai-dot--hot" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-scale-labels" }, [
    /*#__PURE__*/_createElementVNode("span", null, "less confident"),
    /*#__PURE__*/_createElementVNode("span", null, "more confident")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "nge-cl-tags-hint",
    style: {"margin-top":"8px"}
  }, " Jump ↗ to a candidate to see the proposed split as a red and blue point constellation, fix it, and mark it resolved. ")
], -1 /* HOISTED */))
const _hoisted_137 = { class: "nge-cl-tags-lanes" }
const _hoisted_138 = {
  class: "nge-cl-notes",
  style: {"align-self":"center"}
}
const _hoisted_139 = ["title"]
const _hoisted_140 = {
  key: 0,
  class: "nge-cl-tags-hint",
  style: {"padding":"10px 4px"}
}
const _hoisted_141 = {
  key: 1,
  class: "nge-cl-tags-lanes"
}
const _hoisted_142 = ["title", "onClick"]
const _hoisted_143 = ["onClick", "title"]
const _hoisted_144 = { class: "nge-cl-ai-group-caret" }
const _hoisted_145 = { class: "nge-cl-ai-group-name" }
const _hoisted_146 = { class: "nge-cl-notes" }
const _hoisted_147 = ["disabled", "onClick"]
const _hoisted_148 = { class: "nge-cl-row" }
const _hoisted_149 = { class: "nge-cl-row-left" }
const _hoisted_150 = { class: "nge-cl-row-info" }
const _hoisted_151 = { class: "nge-cl-row-name" }
const _hoisted_152 = {
  key: 0,
  class: "nge-cl-notes"
}
const _hoisted_153 = { class: "nge-cl-row-meta" }
const _hoisted_154 = { class: "nge-cl-notes" }
const _hoisted_155 = {
  key: 0,
  class: "nge-cl-badge",
  style: {"background":"rgba(245,209,66,0.12)","color":"#f5d142"}
}
const _hoisted_156 = { class: "nge-cl-row-actions" }
const _hoisted_157 = { class: "nge-orbit-wrap" }
const _hoisted_158 = {
  key: 0,
  class: "nge-orbit-dot",
  "aria-hidden": "true"
}
const _hoisted_159 = ["onClick", "disabled", "title"]
const _hoisted_160 = ["disabled", "onClick"]
const _hoisted_161 = ["onClick"]
const _hoisted_162 = ["onClick"]
const _hoisted_163 = ["onClick"]
const _hoisted_164 = { class: "nge-cl-row nge-cl-row--done" }
const _hoisted_165 = { class: "nge-cl-row-left" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-pip",
  style: {"background":"#556"}
}, null, -1 /* HOISTED */))
const _hoisted_167 = { class: "nge-cl-row-info" }
const _hoisted_168 = { class: "nge-cl-row-name" }
const _hoisted_169 = { class: "nge-cl-row-meta" }
const _hoisted_170 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_171 = { class: "nge-cl-notes" }
const _hoisted_172 = { class: "nge-cl-row-actions" }
const _hoisted_173 = ["onClick"]
const _hoisted_174 = ["onClick"]
const _hoisted_175 = { class: "nge-cl-list" }
const _hoisted_176 = {
  key: 0,
  class: "nge-cl-help-create"
}
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-help-create-title" }, "Save Current View", -1 /* HOISTED */))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-help-create-hint" }, " Captures the current URL, dataset, position, and visible segments. ", -1 /* HOISTED */))
const _hoisted_179 = ["onKeydown"]
const _hoisted_180 = { class: "nge-cl-link-public-row" }
const _hoisted_181 = { class: "nge-cl-help-create-actions" }
const _hoisted_182 = { class: "nge-cl-link-ownership" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-link-ownership-divider" }, null, -1 /* HOISTED */))
const _hoisted_184 = {
  key: 0,
  class: "nge-cl-empty"
}
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "+", -1 /* HOISTED */))
const _hoisted_186 = { class: "nge-cl-row" }
const _hoisted_187 = { class: "nge-cl-row-left" }
const _hoisted_188 = { class: "nge-cl-row-info" }
const _hoisted_189 = {
  key: 0,
  class: "nge-cl-link-rename"
}
const _hoisted_190 = ["onKeydown", "onBlur"]
const _hoisted_191 = ["onDblclick", "title"]
const _hoisted_192 = { class: "nge-cl-row-meta" }
const _hoisted_193 = {
  key: 1,
  class: "nge-cl-notes"
}
const _hoisted_194 = {
  key: 2,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_195 = { class: "nge-cl-notes" }
const _hoisted_196 = {
  key: 2,
  class: "nge-cl-help-note"
}
const _hoisted_197 = { class: "nge-cl-row-actions" }
const _hoisted_198 = ["onClick"]
const _hoisted_199 = ["onClick", "title"]
const _hoisted_200 = ["onClick"]
const _hoisted_201 = ["onClick"]
const _hoisted_202 = ["onClick"]
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-loading" }, "Loading cells...", -1 /* HOISTED */))
const _hoisted_204 = { class: "nge-cl-empty" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No cells loaded yet.", -1 /* HOISTED */))
const _hoisted_206 = {
  key: 0,
  class: "nge-cl-hint"
}
const _hoisted_207 = { class: "nge-cl-list" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-error-dismiss" }, "×", -1 /* HOISTED */))
const _hoisted_209 = {
  key: 1,
  class: "nge-cl-no-results"
}
const _hoisted_210 = {
  key: 2,
  class: "nge-cl-no-results"
}
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_212 = {
  key: 3,
  class: "nge-cl-no-results"
}
const _hoisted_213 = { class: "nge-cl-row-left" }
const _hoisted_214 = { class: "nge-cl-row-info" }
const _hoisted_215 = ["onClick", "title"]
const _hoisted_216 = {
  key: 0,
  class: "nge-cl-copied"
}
const _hoisted_217 = { class: "nge-cl-row-meta" }
const _hoisted_218 = {
  key: 0,
  class: "nge-cl-viewing"
}
const _hoisted_219 = {
  key: 1,
  class: "nge-cl-claimer"
}
const _hoisted_220 = {
  key: 2,
  class: "nge-cl-notes"
}
const _hoisted_221 = { class: "nge-cl-row-actions" }
const _hoisted_222 = ["onClick", "title"]
const _hoisted_223 = ["onClick"]
const _hoisted_224 = ["onClick"]
const _hoisted_225 = ["onClick"]
const _hoisted_226 = {
  key: 10,
  class: "nge-cl-login-hint"
}
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 12 12",
  width: "12",
  height: "12",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 5 L5 11 M11 9 L9 11" })
], -1 /* HOISTED */))
const _hoisted_228 = [
  _hoisted_227
]
const _hoisted_229 = ["onClick"]
const _hoisted_230 = { class: "nge-cl-jumpconfirm" }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-jumpconfirm-title" }, "⚠ Switching dataset", -1 /* HOISTED */))
const _hoisted_232 = { class: "nge-cl-jumpconfirm-body" }
const _hoisted_233 = {
  key: 0,
  class: "nge-cl-jumpconfirm-warn"
}
const _hoisted_234 = {
  key: 1,
  class: "nge-cl-jumpconfirm-warn"
}
const _hoisted_235 = { class: "nge-cl-jumpconfirm-url-row" }
const _hoisted_236 = ["value"]
const _hoisted_237 = { class: "nge-cl-jumpconfirm-save-row" }
const _hoisted_238 = ["disabled"]
const _hoisted_239 = { class: "nge-cl-jumpconfirm-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        name: "nge-cl",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: "panelEl",
            class: "nge-cl-panel",
            style: _normalizeStyle($setup.panelStyle)
          }, [
            _createCommentVNode(" Top bar "),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-cl-topbar", { 'nge-cl-dragging': $setup.isDragging }]),
              onMousedown: $setup.startDrag
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: $setup.neuronIcon,
                  class: "nge-cl-icon"
                }, null, 8 /* PROPS */, _hoisted_2),
                _createTextVNode(" CELL LIBRARY ")
              ]),
              _createElementVNode("button", {
                class: "nge-cl-gear",
                title: "Choose which tabs show",
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[1] || (_cache[1] = $event => ($setup.showTabSettings = !$setup.showTabSettings))
              }, "⚙", 32 /* HYDRATE_EVENTS */),
              _createElementVNode("button", {
                class: "nge-cl-close",
                onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[3] || (_cache[3] = $event => ($setup.emit('hide')))
              }, "×", 32 /* HYDRATE_EVENTS */)
            ], 34 /* CLASS, HYDRATE_EVENTS */),
            _createCommentVNode(" Resolve celebration "),
            _createVNode(_Transition, { name: "nge-cl-tagwin" }, {
              default: _withCtx(() => [
                ($setup.tagSuccessToast)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "nge-cl-tagwin",
                      onClick: _cache[4] || (_cache[4] = $event => ($setup.tagSuccessToast = false))
                    }, [
                      _createElementVNode("div", {
                        class: "nge-cl-tagwin-glyph",
                        innerHTML: $setup.tagPinSvg
                      }, null, 8 /* PROPS */, _hoisted_3),
                      _hoisted_4,
                      _hoisted_5
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Per-user tab picker "),
            ($setup.showTabSettings)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nge-cl-tabsettings",
                  onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _hoisted_6,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ALL_CL_TABS, (t) => {
                    return _createElementVNode("label", {
                      key: t.key,
                      class: "nge-cl-tabsettings-row"
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: $setup.visibleTabs.includes(t.key),
                        onChange: $event => ($setup.toggleTab(t.key))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7),
                      _createElementVNode("span", null, _toDisplayString(t.label), 1 /* TEXT */)
                    ])
                  }), 64 /* STABLE_FRAGMENT */))
                ], 32 /* HYDRATE_EVENTS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Filter tabs "),
            _createElementVNode("div", _hoisted_8, [
              ($setup.tabShown('mine'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass({ active: $setup.filter === 'mine' }),
                    onClick: _cache[6] || (_cache[6] = $event => ($setup.filter = 'mine'))
                  }, " My Cells (" + _toDisplayString($setup.myClaimCount) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('available'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass({ active: $setup.filter === 'available' }),
                    onClick: _cache[7] || (_cache[7] = $event => ($setup.filter = 'available'))
                  }, " Available (" + _toDisplayString($setup.availableCount) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('claimed'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: _normalizeClass({ active: $setup.filter === 'claimed', 'nge-cl-claimed-tab': true }),
                    onClick: _cache[8] || (_cache[8] = $event => ($setup.filter = 'claimed'))
                  }, " Claimed (" + _toDisplayString($setup.claimedCount) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('all'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: _normalizeClass({ active: $setup.filter === 'all' }),
                    onClick: _cache[9] || (_cache[9] = $event => ($setup.filter = 'all'))
                  }, " All (" + _toDisplayString($setup.datasetScopedCells.length) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('completed'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: _normalizeClass({ active: $setup.filter === 'completed' }),
                    onClick: _cache[10] || (_cache[10] = $event => ($setup.filter = 'completed'))
                  }, " Completed (" + _toDisplayString($setup.completedCount) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('help'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    class: _normalizeClass({ active: $setup.filter === 'help', 'nge-cl-help-tab': true }),
                    onClick: _cache[11] || (_cache[11] = $event => ($setup.filter = 'help'))
                  }, " Help (" + _toDisplayString($setup.pendingHelp.length) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('tags'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    class: _normalizeClass({ active: $setup.filter === 'tags', 'nge-cl-tags-tab': true }),
                    onClick: _cache[12] || (_cache[12] = $event => ($setup.filter = 'tags'))
                  }, " Tags (" + _toDisplayString($setup.datasetTags.length) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('ai'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 7,
                    class: _normalizeClass({ active: $setup.filter === 'ai', 'nge-cl-ai-tab': true }),
                    onClick: _cache[13] || (_cache[13] = $event => ($setup.filter = 'ai'))
                  }, " AI (" + _toDisplayString($setup.aiDatasetTags.length) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('links'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 8,
                    class: _normalizeClass({ active: $setup.filter === 'links', 'nge-cl-links-tab': true }),
                    onClick: _cache[14] || (_cache[14] = $event => ($setup.filter = 'links'))
                  }, " My Saved Links (" + _toDisplayString($setup.linksStore.links.length) + ") ", 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Search (not shown on Help / Links tabs) "),
            ($setup.filter !== 'help' && $setup.filter !== 'links' && $setup.filter !== 'tags' && $setup.filter !== 'ai')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.search) = $event)),
                    placeholder: "Search by ID, name, or notes...",
                    class: "nge-cl-search-input",
                    onKeydown: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                    onKeyup: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.search]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Search on Links tab "),
            ($setup.filter === 'links')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => (($setup.linksSearch) = $event)),
                    placeholder: "Search links by title, note, or dataset...",
                    class: "nge-cl-search-input",
                    onKeydown: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
                    onKeyup: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.linksSearch]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ═══ HELP TAB ═══ "),
            ($setup.filter === 'help')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createCommentVNode(" Always-visible quick-add: submit a new help request from the top "),
                  _createCommentVNode(" Collapsed by default: a permanently-open form at the top of the\n               tab read as an alert rather than an action. "),
                  (!$setup.helpFormOpen)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-cl-help-open-btn",
                        onClick: $setup.toggleHelpForm,
                        title: "Ask another proofreader to look at a cell"
                      }, [
                        _hoisted_12,
                        _createTextVNode(" Submit a help request ")
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", { class: "nge-cl-help-quickadd-title" }, [
                          _createTextVNode(" Submit a help request "),
                          _createElementVNode("button", {
                            class: "nge-cl-help-collapse",
                            onClick: $setup.toggleHelpForm,
                            title: "Collapse"
                          }, "▾")
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => (($setup.newHelpSegId) = $event)),
                            class: "nge-cl-help-segid-input",
                            placeholder: "Segment ID",
                            inputmode: "numeric",
                            onKeydown: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"])),
                            onKeyup: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                            onKeypress: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                            onInput: _cache[27] || (_cache[27] = $event => ($setup.newHelpError = ''))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelText, $setup.newHelpSegId]
                          ]),
                          _createElementVNode("button", {
                            class: "nge-cl-help-segid-use",
                            onClick: _cache[28] || (_cache[28] = $event => {$setup.newHelpSegId = $setup.getActiveSegId(); $setup.newHelpError = ''}),
                            title: "Use the segment currently selected in the viewer"
                          }, "Use selected"),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (($setup.newHelpIssue) = $event)),
                            class: "nge-cl-help-issue-select",
                            onKeydown: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"])),
                            title: "Issue type"
                          }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.HELP_ISSUE_TYPES, (t) => {
                              return _createElementVNode("option", {
                                key: t,
                                value: t
                              }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_15)
                            }), 64 /* STABLE_FRAGMENT */))
                          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelSelect, $setup.newHelpIssue]
                          ]),
                          _createCommentVNode(" Same annotation-layer picker the reply form has: point a\n                   reviewer at the layer holding your marks from the start,\n                   instead of only being able to add one when replying. "),
                          ($setup.getAnnotationLayers().length > 0)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => (($setup.newHelpAnnotationLayer) = $event)),
                                class: "nge-cl-help-issue-select",
                                onKeydown: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"])),
                                title: "Attach an annotation layer (optional)"
                              }, [
                                _hoisted_16,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAnnotationLayers(), (layer) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: layer,
                                    value: layer
                                  }, _toDisplayString(layer), 9 /* TEXT, PROPS */, _hoisted_17))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)), [
                                [_vModelSelect, $setup.newHelpAnnotationLayer]
                              ])
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => (($setup.newHelpNote) = $event)),
                            class: "nge-cl-help-note-input",
                            placeholder: "Describe what looks wrong, then press Enter…",
                            onKeydown: [
                              _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"])),
                              _withKeys(_withModifiers($setup.submitNewHelp, ["prevent"]), ["enter"])
                            ],
                            onKeyup: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"])),
                            onKeypress: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"])),
                            onInput: _cache[37] || (_cache[37] = $event => ($setup.newHelpError = ''))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_19), [
                            [_vModelText, $setup.newHelpNote]
                          ]),
                          (!$setup.newHelpScreenshotUrl)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "nge-cl-help-shot-icon",
                                onClick: _cache[38] || (_cache[38] = $event => ($setup.showHelpScreenshotDialog = true)),
                                title: "Attach a screenshot of the current view"
                              }, _hoisted_21))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "nge-cl-help-shot-icon nge-cl-help-shot-icon--attached",
                                onClick: $setup.clearHelpScreenshot,
                                title: "Screenshot attached — click to remove"
                              }, "✓")),
                          _createElementVNode("button", {
                            class: "nge-cl-help-quickadd-submit",
                            onClick: $setup.submitNewHelp,
                            title: "Submit help request"
                          }, "Submit")
                        ]),
                        ($setup.newHelpScreenshotUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("img", {
                                src: $setup.newHelpScreenshotUrl,
                                alt: "Attached screenshot"
                              }, null, 8 /* PROPS */, _hoisted_23),
                              _createElementVNode("button", {
                                class: "nge-cl-help-shot-remove",
                                onClick: $setup.clearHelpScreenshot,
                                title: "Remove screenshot"
                              }, "×")
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.newHelpError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.newHelpError), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])),
                  _createCommentVNode(" Pending help requests "),
                  ($setup.pendingHelp.length === 0 && $setup.resolvedHelp.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, " No help requests yet. Use the box above to submit one. "))
                    : ($setup.pendingHelp.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "No pending requests"))
                      : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pendingHelpByDataset, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.dataset,
                      class: _normalizeClass(["nge-cl-help-ds-group", { 'nge-cl-help-ds-group--cross': !group.isCurrent }])
                    }, [
                      _createCommentVNode(" Dataset section header: shown with multiple groups, and ALSO\n                 for a lone non-current group. Without it, requests that all\n                 live in one other dataset auto-collapsed with no header to\n                 expand them: count said 2, list showed nothing (Amy). "),
                      ($setup.hasMultipleHelpDatasets || !group.isCurrent)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "nge-cl-help-ds-header",
                            onClick: $event => ($setup.toggleDatasetGroup(group.dataset))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["nge-cl-help-ds-arrow", { 'nge-cl-help-ds-arrow--collapsed': !group.isCurrent && $setup.collapsedDatasets.has(group.dataset) }])
                            }, "▾", 2 /* CLASS */),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(group.label), 1 /* TEXT */),
                            (group.isCurrent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "current"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_30, "other dataset")),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(group.requests.length), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_27))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Requests: current dataset always shown; others only when expanded "),
                      (group.isCurrent || !$setup.collapsedDatasets.has(group.dataset))
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(group.requests, (req) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: req.id,
                              class: _normalizeClass(["nge-cl-help-item", {
                  'nge-cl-help-item--active': $setup.activeHelpId === req.id,
                  'nge-cl-help-item--cross': !group.isCurrent,
                }])
                            }, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _hoisted_34,
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", {
                                      class: "nge-cl-row-name",
                                      onClick: $event => ($setup.copyId(req.segId)),
                                      title: 'Click to copy ' + req.segId
                                    }, [
                                      _createTextVNode(_toDisplayString(req.segId) + " ", 1 /* TEXT */),
                                      ($setup.copiedId === req.segId)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "copied"))
                                        : _createCommentVNode("v-if", true)
                                    ], 8 /* PROPS */, _hoisted_36),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(req.issueType), 1 /* TEXT */),
                                      (req.userName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "by " + _toDisplayString(req.userName), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("span", _hoisted_41, _toDisplayString($setup.relativeTime(req.createdAt)), 1 /* TEXT */)
                                    ]),
                                    (req.note)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["nge-cl-help-note", { 'nge-cl-help-note--expanded': $setup.expandedNotes.has(req.id) }]),
                                          onClick: $event => ($setup.toggleNoteExpand(req.id))
                                        }, _toDisplayString(req.note), 11 /* TEXT, CLASS, PROPS */, _hoisted_42))
                                      : _createCommentVNode("v-if", true),
                                    (req.screenshotUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          href: req.screenshotUrl,
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "nge-cl-help-shot-thumb",
                                          title: 'Open full screenshot'
                                        }, [
                                          _createElementVNode("img", {
                                            src: req.screenshotUrl,
                                            alt: "Help screenshot"
                                          }, null, 8 /* PROPS */, _hoisted_44)
                                        ], 8 /* PROPS */, _hoisted_43))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn nge-cl-btn--jump",
                                    onClick: $event => ($setup.jumpToReq(req)),
                                    title: !group.isCurrent ? `Switch to ${group.label} and jump` : 'Jump to segment'
                                  }, "↗", 8 /* PROPS */, _hoisted_46),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn nge-cl-btn--respond",
                                    onClick: $event => ($setup.toggleResponseForm(req.id)),
                                    title: $setup.respondingTo === req.id ? 'Cancel' : 'Respond'
                                  }, _toDisplayString($setup.respondingTo === req.id ? '▾' : '💬'), 9 /* TEXT, PROPS */, _hoisted_47),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn nge-cl-btn--complete",
                                    onClick: $event => ($setup.resolveReq(req))
                                  }, "Resolve", 8 /* PROPS */, _hoisted_48)
                                ])
                              ]),
                              _createCommentVNode(" Reply thread: one entry per help_responses row (each keeps its\n                 own link / annotation layer / screenshot). "),
                              (req.responses && req.responses.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.responses, (resp) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: resp.id,
                                        class: "nge-cl-response-item"
                                      }, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createTextVNode("💬 " + _toDisplayString(resp.userName || 'Response'), 1 /* TEXT */),
                                          (resp.resolved)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, " · resolved"))
                                            : _createCommentVNode("v-if", true),
                                          _createTextVNode(":")
                                        ]),
                                        (resp.note)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(resp.note), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        (resp.url)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              class: "nge-cl-response-link",
                                              onClick: _withModifiers($event => ($setup.openResponseUrl(resp.url)), ["prevent"]),
                                              href: "#"
                                            }, "↗ View linked state", 8 /* PROPS */, _hoisted_53))
                                          : _createCommentVNode("v-if", true),
                                        (resp.annotationLayer)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, "📐 Layer: " + _toDisplayString(resp.annotationLayer), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        (resp.screenshotUrl)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 3,
                                              href: resp.screenshotUrl,
                                              target: "_blank",
                                              rel: "noopener",
                                              class: "nge-cl-help-shot-thumb",
                                              title: "Open full screenshot"
                                            }, [
                                              _createElementVNode("img", {
                                                src: resp.screenshotUrl,
                                                alt: "Reply screenshot"
                                              }, null, 8 /* PROPS */, _hoisted_56)
                                            ], 8 /* PROPS */, _hoisted_55))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    ($setup.respondingTo !== req.id)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "nge-cl-btn nge-cl-btn--reply",
                                          onClick: $event => ($setup.toggleResponseForm(req.id))
                                        }, "↩ Reply", 8 /* PROPS */, _hoisted_57))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _createCommentVNode(" Inline response form (below existing thread) "),
                              ($setup.respondingTo === req.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => (($setup.responseNote) = $event)),
                                      placeholder: "Write your response... (Enter to submit, Shift+Enter for newline)",
                                      class: "nge-cl-response-textarea",
                                      rows: "3",
                                      onKeydown: [
                                        _cache[40] || (_cache[40] = _withModifiers(() => {}, ["stop"])),
                                        _withKeys(_withModifiers($event => ($setup.submitResponse(req)), ["exact","prevent"]), ["enter"])
                                      ],
                                      onKeyup: _cache[41] || (_cache[41] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_59), [
                                      [_vModelText, $setup.responseNote]
                                    ]),
                                    _createElementVNode("div", _hoisted_60, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => (($setup.responseUrl) = $event)),
                                        placeholder: "Neuroglancer state URL (optional)",
                                        class: "nge-cl-response-input",
                                        onKeydown: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"])),
                                        onKeyup: _cache[45] || (_cache[45] = _withModifiers(() => {}, ["stop"])),
                                        onKeypress: _cache[46] || (_cache[46] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelText, $setup.responseUrl]
                                      ]),
                                      _createElementVNode("button", {
                                        class: "nge-cl-btn nge-cl-btn--copy-state",
                                        onClick: $setup.copyCurrentState,
                                        title: "Copy current viewer state URL"
                                      }, "📋 State")
                                    ]),
                                    ($setup.getAnnotationLayers().length > 0)
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 0,
                                          "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => (($setup.responseAnnotationLayer) = $event)),
                                          class: "nge-cl-response-input"
                                        }, [
                                          _hoisted_61,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAnnotationLayers(), (layer) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: layer,
                                              value: layer
                                            }, _toDisplayString(layer), 9 /* TEXT, PROPS */, _hoisted_62))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */)), [
                                          [_vModelSelect, $setup.responseAnnotationLayer]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Attach an (optionally annotated) screenshot to the reply,\n                   same flow as the initial request. "),
                                    (!$setup.responseScreenshotUrl)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-btn nge-cl-help-shot-btn",
                                          onClick: _cache[48] || (_cache[48] = $event => ($setup.showResponseScreenshotDialog = true)),
                                          title: "Attach a screenshot of the current view"
                                        }, "📷 Attach screenshot"))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                          _createElementVNode("img", {
                                            src: $setup.responseScreenshotUrl,
                                            alt: "Reply screenshot"
                                          }, null, 8 /* PROPS */, _hoisted_64),
                                          _createElementVNode("button", {
                                            class: "nge-cl-help-shot-remove",
                                            onClick: $setup.clearResponseScreenshot,
                                            title: "Remove screenshot"
                                          }, "×")
                                        ])),
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn nge-cl-btn--submit-response",
                                      disabled: !$setup.responseNote.trim() && !$setup.responseScreenshotUrl,
                                      onClick: $event => ($setup.submitResponse(req))
                                    }, "Submit Response", 8 /* PROPS */, _hoisted_65),
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn nge-cl-btn--submit-response nge-cl-btn--resolve",
                                      disabled: !$setup.responseNote.trim() && !$setup.responseScreenshotUrl,
                                      onClick: $event => ($setup.submitResponse(req, true))
                                    }, "Submit & Resolve", 8 /* PROPS */, _hoisted_66)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 2 /* CLASS */))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createCommentVNode(" Resolved section "),
                  ($setup.resolvedHelp.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: "nge-cl-help-resolved-header",
                        onClick: _cache[49] || (_cache[49] = $event => ($setup.showResolved = !$setup.showResolved))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["nge-cl-help-resolved-arrow", { 'nge-cl-help-resolved-arrow--open': $setup.showResolved }])
                        }, "▸", 2 /* CLASS */),
                        _createTextVNode(" Resolved (" + _toDisplayString($setup.resolvedHelp.length) + ") ", 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.showResolved)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList($setup.resolvedHelp, (req) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: req.id,
                          class: "nge-cl-help-item"
                        }, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _hoisted_69,
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", {
                                  class: "nge-cl-row-name",
                                  onClick: $event => ($setup.copyId(req.segId)),
                                  title: 'Click to copy ' + req.segId
                                }, _toDisplayString(req.segId), 9 /* TEXT, PROPS */, _hoisted_71),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("span", _hoisted_73, _toDisplayString(req.issueType), 1 /* TEXT */),
                                  (req.resolvedByName)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_74, "✓ " + _toDisplayString(req.resolvedByName), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("span", _hoisted_75, _toDisplayString($setup.relativeTime(req.createdAt)), 1 /* TEXT */)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("button", {
                                class: "nge-cl-btn nge-cl-btn--jump",
                                onClick: $event => ($setup.jumpToReq(req)),
                                title: "Jump to segment"
                              }, "↗", 8 /* PROPS */, _hoisted_77),
                              _createElementVNode("button", {
                                class: "nge-cl-btn nge-cl-btn--release",
                                onClick: $event => ($setup.removeReq(req)),
                                title: "Remove"
                              }, "×", 8 /* PROPS */, _hoisted_78)
                            ])
                          ]),
                          _createCommentVNode(" Response display: one entry per help_responses row "),
                          (req.responses && req.responses.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.responses, (resp) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: resp.id,
                                    class: "nge-cl-response-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_80, [
                                      _createTextVNode(_toDisplayString(resp.userName || 'Response'), 1 /* TEXT */),
                                      (resp.resolved)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_81, " · resolved"))
                                        : _createCommentVNode("v-if", true),
                                      _createTextVNode(":")
                                    ]),
                                    (resp.note)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(resp.note), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (resp.url)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          class: "nge-cl-response-link",
                                          onClick: _withModifiers($event => ($setup.openResponseUrl(resp.url)), ["prevent"]),
                                          href: "#"
                                        }, "↗ View linked state", 8 /* PROPS */, _hoisted_83))
                                      : _createCommentVNode("v-if", true),
                                    (resp.annotationLayer)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_84, "📐 Layer: " + _toDisplayString(resp.annotationLayer), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (resp.screenshotUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 3,
                                          href: resp.screenshotUrl,
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "nge-cl-help-shot-thumb",
                                          title: "Open full screenshot"
                                        }, [
                                          _createElementVNode("img", {
                                            src: resp.screenshotUrl,
                                            alt: "Reply screenshot"
                                          }, null, 8 /* PROPS */, _hoisted_86)
                                        ], 8 /* PROPS */, _hoisted_85))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" connectome.quest resources "),
                  _createElementVNode("div", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("div", _hoisted_89, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CONNECTOME_QUEST_RESOURCES, (res) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: res.id,
                          class: "nge-cl-quest-link",
                          href: res.url,
                          target: "_blank",
                          rel: "noopener",
                          title: res.description
                        }, [
                          _createElementVNode("span", _hoisted_91, _toDisplayString(res.icon), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_92, _toDisplayString(res.label), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_90))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : ($setup.filter === 'tags')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createCommentVNode(" ═══ TAGS TAB (Scout tags: mergers / missing branches) ═══ "),
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", _hoisted_95, [
                          _createElementVNode("span", {
                            class: "nge-cl-tag-pin",
                            innerHTML: $setup.tagPinSvg
                          }, null, 8 /* PROPS */, _hoisted_96),
                          _createTextVNode(" Scout tags")
                        ]),
                        _createElementVNode("div", _hoisted_97, [
                          _createTextVNode(" Drop tags with the "),
                          _createElementVNode("span", {
                            class: "nge-cl-tag-pin",
                            innerHTML: $setup.tagPinSvg
                          }, null, 8 /* PROPS */, _hoisted_98),
                          _createTextVNode(" Tag Mode toolbar button: center the crosshair on a merger or a suspected missing branch and pick the type. Scythes jump to each open tag from here, fix it, and mark it resolved. ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("button", {
                          class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagLane === 'all' }),
                          onClick: _cache[50] || (_cache[50] = $event => ($setup.tagLane = 'all'))
                        }, "All (" + _toDisplayString($setup.datasetTags.length) + ")", 3 /* TEXT, CLASS */),
                        _createElementVNode("button", {
                          class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagLane === 'merger' }),
                          onClick: _cache[51] || (_cache[51] = $event => ($setup.tagLane = 'merger'))
                        }, [
                          _createElementVNode("img", {
                            src: $setup.scytheIcon,
                            class: "nge-cl-lane-icon",
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_100),
                          _createTextVNode(" For Scythes")
                        ], 2 /* CLASS */),
                        _createElementVNode("button", {
                          class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagLane === 'missing_branch' }),
                          onClick: _cache[52] || (_cache[52] = $event => ($setup.tagLane = 'missing_branch'))
                        }, [
                          _createElementVNode("img", {
                            src: $setup.tracerIcon,
                            class: "nge-cl-lane-icon",
                            alt: ""
                          }, null, 8 /* PROPS */, _hoisted_101),
                          _createTextVNode(" For Tracers")
                        ], 2 /* CLASS */),
                        _createElementVNode("button", {
                          class: _normalizeClass({ 'nge-cl-lane--active': $setup.showAllDatasetTags }),
                          title: $setup.showAllDatasetTags ? 'Showing every dataset' : 'Showing only ' + ($setup.datasetDisplayName($setup.activeDataset) || 'this dataset'),
                          onClick: _cache[53] || (_cache[53] = $event => ($setup.showAllDatasetTags = !$setup.showAllDatasetTags))
                        }, "🌐 All datasets (" + _toDisplayString($setup.humanOpenTags.length) + ")", 11 /* TEXT, CLASS, PROPS */, _hoisted_102)
                      ]),
                      (!$setup.laneFilteredTags.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, " No open tags in this lane. The volume is momentarily unsuspicious. "))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.laneFilteredTags, (tag, tagIdx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: tag.id,
                          class: "nge-cl-help-item"
                        }, [
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("div", _hoisted_105, [
                              _createElementVNode("span", {
                                class: "nge-cl-pip",
                                style: _normalizeStyle({ background: $setup.TAG_TYPE_META[tag.tagType]?.pip ?? '#889' })
                              }, null, 4 /* STYLE */),
                              _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, [
                                  _createTextVNode(_toDisplayString($setup.tagLabel(tag)) + " ", 1 /* TEXT */),
                                  (tag.segId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_108, " · seg …" + _toDisplayString(tag.segId.slice(-6)), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("span", _hoisted_110, _toDisplayString(tag.position.join(', ')), 1 /* TEXT */),
                                  ($setup.isCrossDatasetTag(tag))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString($setup.datasetDisplayName(tag.dataset)), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("span", _hoisted_112, _toDisplayString(tag.userName || 'Anonymous') + " · " + _toDisplayString($setup.relativeTime(tag.createdAt)), 1 /* TEXT */)
                                ]),
                                (tag.note)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, _toDisplayString(tag.note), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (tag.annotationLayer)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, "📐 " + _toDisplayString(tag.annotationLayer), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (tag.screenshotUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      href: tag.screenshotUrl,
                                      target: "_blank",
                                      rel: "noopener",
                                      class: "nge-cl-help-shot-thumb",
                                      title: "Open full screenshot"
                                    }, [
                                      _createElementVNode("img", {
                                        src: tag.screenshotUrl,
                                        alt: "Tag screenshot"
                                      }, null, 8 /* PROPS */, _hoisted_116)
                                    ], 8 /* PROPS */, _hoisted_115))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("span", _hoisted_118, [
                                ($setup.orbitOn(tagIdx, $setup.laneFilteredTags.length))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_119))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("button", {
                                  class: "nge-cl-btn nge-cl-btn--jump",
                                  onClick: $event => ($setup.jumpToTag(tag)),
                                  disabled: $setup.isCrossDatasetTag(tag),
                                  title: $setup.isCrossDatasetTag(tag) ? 'Switch to ' + $setup.datasetDisplayName(tag.dataset) + ' first' : 'Jump to location'
                                }, "↗", 8 /* PROPS */, _hoisted_120)
                              ]),
                              _createElementVNode("button", {
                                class: "nge-cl-btn nge-cl-btn--complete nge-cl-btn--tagdone",
                                onClick: $event => ($setup.resolveTagFun(tag, $event)),
                                title: "I fixed this! Claim the tag"
                              }, "✓", 8 /* PROPS */, _hoisted_121),
                              ($setup.confirmDeleteTagId === tag.id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn nge-cl-btn--confirmdel",
                                      onClick: $event => ($setup.confirmDeleteTag(tag)),
                                      title: "Yes, delete this tag for everyone"
                                    }, "Delete?", 8 /* PROPS */, _hoisted_122),
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn",
                                      onClick: _cache[54] || (_cache[54] = $event => ($setup.confirmDeleteTagId = null)),
                                      title: "Keep the tag"
                                    }, "✕")
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "nge-cl-btn nge-cl-btn--release",
                                    onClick: $event => ($setup.askDeleteTag(tag)),
                                    title: "Delete this tag for everyone (use ✓ if it was fixed)"
                                  }, "🗑", 8 /* PROPS */, _hoisted_123))
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      _createElementVNode("div", {
                        class: "nge-cl-help-resolved-toggle",
                        onClick: _cache[55] || (_cache[55] = $event => ($setup.showResolvedTags = !$setup.showResolvedTags))
                      }, _toDisplayString($setup.showResolvedTags ? '▾' : '▸') + " Resolved (" + _toDisplayString($setup.resolvedTags.length) + ") ", 1 /* TEXT */),
                      ($setup.showResolvedTags)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.resolvedTags, (tag) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tag.id,
                              class: "nge-cl-help-item"
                            }, [
                              _createElementVNode("div", _hoisted_124, [
                                _createElementVNode("div", _hoisted_125, [
                                  _hoisted_126,
                                  _createElementVNode("div", _hoisted_127, [
                                    _createElementVNode("div", _hoisted_128, _toDisplayString($setup.tagLabel(tag)), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_129, [
                                      (tag.resolvedByName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_130, "✓ " + _toDisplayString(tag.resolvedByName), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("span", _hoisted_131, _toDisplayString($setup.relativeTime(tag.createdAt)), 1 /* TEXT */)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_132, [
                                  ($setup.confirmDeleteTagId === tag.id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("button", {
                                          class: "nge-cl-btn nge-cl-btn--confirmdel",
                                          onClick: $event => ($setup.confirmDeleteTag(tag)),
                                          title: "Yes, delete this tag for everyone"
                                        }, "Delete?", 8 /* PROPS */, _hoisted_133),
                                        _createElementVNode("button", {
                                          class: "nge-cl-btn",
                                          onClick: _cache[56] || (_cache[56] = $event => ($setup.confirmDeleteTagId = null)),
                                          title: "Keep the tag"
                                        }, "✕")
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "nge-cl-btn nge-cl-btn--release",
                                        onClick: $event => ($setup.askDeleteTag(tag)),
                                        title: "Delete this tag for everyone"
                                      }, "🗑", 8 /* PROPS */, _hoisted_134))
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : ($setup.filter === 'ai')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createCommentVNode(" ═══ AI TAB (model-detected merge-error candidates) ═══ "),
                      _createElementVNode("div", _hoisted_135, [
                        _hoisted_136,
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("span", _hoisted_138, _toDisplayString($setup.aiDatasetTags.length) + " candidates on " + _toDisplayString($setup.aiGroups.length) + " " + _toDisplayString($setup.aiGroups.length === 1 ? 'cell' : 'cells'), 1 /* TEXT */),
                          _createElementVNode("button", {
                            class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagStore.aiLayerOn }),
                            title: $setup.tagStore.aiLayerOn ? 'Hide AI candidate markers in the viewer' : 'Show AI candidate markers in the viewer',
                            onClick: _cache[57] || (_cache[57] = $event => ($setup.tagStore.setAiLayerOn(!$setup.tagStore.aiLayerOn)))
                          }, "📍 Markers", 10 /* CLASS, PROPS */, _hoisted_139)
                        ]),
                        (!$setup.aiDatasetTags.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                              _createTextVNode(" No open AI candidates for this dataset. "),
                              (!$setup.aiElsewhere.length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" The model finds no fault here.")
                                  ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (!$setup.aiDatasetTags.length && $setup.aiElsewhere.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.aiElsewhere, (e) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: e.ds.id,
                                  class: "nge-cl-lane--active",
                                  title: 'Switch the viewer to ' + e.ds.label,
                                  onClick: $event => ($setup.switchToAiDataset(e.ds))
                                }, _toDisplayString($setup.SPECIES_ICONS[e.ds.species]) + " Switch to " + _toDisplayString(e.ds.shortLabel) + " (" + _toDisplayString(e.count) + " candidates) ", 9 /* TEXT, PROPS */, _hoisted_142))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.aiGroups, (g) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: g.root
                          }, [
                            _createElementVNode("div", {
                              class: "nge-cl-ai-group",
                              onClick: $event => ($setup.toggleAiGroup(g.root)),
                              title: $setup.aiGroupExpanded(g.root) ? 'Collapse this cell' : 'Expand this cell'
                            }, [
                              _createElementVNode("span", _hoisted_144, _toDisplayString($setup.aiGroupExpanded(g.root) ? '▾' : '▸'), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_145, "🧠 Cell …" + _toDisplayString(g.root.slice(-6)), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_146, _toDisplayString(g.tags.length) + " " + _toDisplayString(g.tags.length === 1 ? 'candidate' : 'candidates'), 1 /* TEXT */),
                              _createElementVNode("button", {
                                class: _normalizeClass(["nge-cl-ai-group-heat", { 'nge-cl-lane--active': $setup.tagStore.activeHeatRoots.includes(g.root) }]),
                                disabled: $setup.tagStore.heatLoadingRoot === g.root,
                                title: "Heat layer: every window the model scored on this cell, cool to hot",
                                onClick: _withModifiers($event => ($setup.tagStore.toggleHeatLayer(g.root)), ["stop"])
                              }, _toDisplayString($setup.tagStore.heatLoadingRoot === g.root ? '⏳' : '🔥') + " Heat ", 11 /* TEXT, CLASS, PROPS */, _hoisted_147)
                            ], 8 /* PROPS */, _hoisted_143),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.tags, (tag, tagIdx) => {
                              return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: tag.id,
                                class: "nge-cl-help-item"
                              }, [
                                _createElementVNode("div", _hoisted_148, [
                                  _createElementVNode("div", _hoisted_149, [
                                    _createElementVNode("span", {
                                      class: "nge-cl-pip",
                                      style: _normalizeStyle({ background: $setup.confColor(tag.confidence) })
                                    }, null, 4 /* STYLE */),
                                    _createElementVNode("div", _hoisted_150, [
                                      _createElementVNode("div", _hoisted_151, [
                                        _createTextVNode(_toDisplayString($setup.aiCategoryIcon(tag)) + " Cut ", 1 /* TEXT */),
                                        _createElementVNode("span", {
                                          class: "nge-cl-ai-conf",
                                          style: _normalizeStyle({ color: $setup.confColor(tag.confidence) })
                                        }, _toDisplayString(Math.round((tag.confidence ?? 0) * 100)) + "%", 5 /* TEXT, STYLE */),
                                        (tag.segId)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_152, " · seg …" + _toDisplayString(tag.segId.slice(-6)), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_153, [
                                        _createElementVNode("span", _hoisted_154, _toDisplayString(tag.position.join(', ')), 1 /* TEXT */),
                                        ($setup.isCrossDatasetTag(tag))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_155, _toDisplayString($setup.datasetDisplayName(tag.dataset)), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_156, [
                                    _createElementVNode("span", _hoisted_157, [
                                      ($setup.orbitOn(tagIdx, g.tags.length))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_158))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("button", {
                                        class: "nge-cl-btn nge-cl-btn--jump",
                                        onClick: $event => ($setup.jumpToAiTag(tag)),
                                        disabled: $setup.isCrossDatasetTag(tag),
                                        title: $setup.isCrossDatasetTag(tag) ? 'Switch to ' + $setup.datasetDisplayName(tag.dataset) + ' first' : 'Jump to location and preview the proposed split'
                                      }, "↗", 8 /* PROPS */, _hoisted_159)
                                    ]),
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["nge-cl-btn nge-cl-btn--split", { 'nge-cl-btn--split-active': $setup.tagStore.activeSplitTagId === tag.id }]),
                                      disabled: !tag.modelData?.posRelUm?.length,
                                      title: "Toggle the model's proposed split overlay",
                                      onClick: $event => ($setup.tagStore.toggleSplitOverlay(tag))
                                    }, "✂", 10 /* CLASS, PROPS */, _hoisted_160),
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn nge-cl-btn--complete nge-cl-btn--tagdone",
                                      onClick: $event => ($setup.resolveTagFun(tag, $event)),
                                      title: "I fixed this! Claim the tag"
                                    }, "✓", 8 /* PROPS */, _hoisted_161),
                                    ($setup.confirmDeleteTagId === tag.id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn nge-cl-btn--confirmdel",
                                            onClick: $event => ($setup.confirmDeleteTag(tag)),
                                            title: "Yes, delete this candidate for everyone"
                                          }, "Delete?", 8 /* PROPS */, _hoisted_162),
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn",
                                            onClick: _cache[58] || (_cache[58] = $event => ($setup.confirmDeleteTagId = null)),
                                            title: "Keep the candidate"
                                          }, "✕")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-btn nge-cl-btn--release",
                                          onClick: $event => ($setup.askDeleteTag(tag)),
                                          title: "Delete this candidate for everyone (use ✓ if it was fixed)"
                                        }, "🗑", 8 /* PROPS */, _hoisted_163))
                                  ])
                                ])
                              ])), [
                                [_vShow, $setup.aiGroupExpanded(g.root)]
                              ])
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createElementVNode("div", {
                          class: "nge-cl-help-resolved-toggle",
                          onClick: _cache[59] || (_cache[59] = $event => ($setup.showResolvedAiTags = !$setup.showResolvedAiTags))
                        }, _toDisplayString($setup.showResolvedAiTags ? '▾' : '▸') + " Resolved (" + _toDisplayString($setup.aiResolvedTags.length) + ") ", 1 /* TEXT */),
                        ($setup.showResolvedAiTags)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.aiResolvedTags, (tag) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: tag.id,
                                class: "nge-cl-help-item"
                              }, [
                                _createElementVNode("div", _hoisted_164, [
                                  _createElementVNode("div", _hoisted_165, [
                                    _hoisted_166,
                                    _createElementVNode("div", _hoisted_167, [
                                      _createElementVNode("div", _hoisted_168, _toDisplayString($setup.aiCategoryIcon(tag)) + " Cut · " + _toDisplayString(Math.round((tag.confidence ?? 0) * 100)) + "%", 1 /* TEXT */),
                                      _createElementVNode("div", _hoisted_169, [
                                        (tag.resolvedByName)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_170, "✓ " + _toDisplayString(tag.resolvedByName), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("span", _hoisted_171, _toDisplayString($setup.relativeTime(tag.createdAt)), 1 /* TEXT */)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_172, [
                                    ($setup.confirmDeleteTagId === tag.id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn nge-cl-btn--confirmdel",
                                            onClick: $event => ($setup.confirmDeleteTag(tag)),
                                            title: "Yes, delete this candidate for everyone"
                                          }, "Delete?", 8 /* PROPS */, _hoisted_173),
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn",
                                            onClick: _cache[60] || (_cache[60] = $event => ($setup.confirmDeleteTagId = null)),
                                            title: "Keep the candidate"
                                          }, "✕")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-btn nge-cl-btn--release",
                                          onClick: $event => ($setup.askDeleteTag(tag)),
                                          title: "Delete this candidate for everyone"
                                        }, "🗑", 8 /* PROPS */, _hoisted_174))
                                  ])
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : ($setup.filter === 'links')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createCommentVNode(" ═══ LINKS TAB ═══ "),
                        _createElementVNode("div", _hoisted_175, [
                          _createCommentVNode(" Save current view form "),
                          _createVNode(_Transition, { name: "nge-slide" }, {
                            default: _withCtx(() => [
                              ($setup.showSaveLinkForm)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                    _hoisted_177,
                                    _hoisted_178,
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => (($setup.newLinkTitle) = $event)),
                                      class: "nge-cl-search-input",
                                      placeholder: "Title (e.g. 'Tricky merge near soma')",
                                      onKeydown: [
                                        _cache[62] || (_cache[62] = _withModifiers(() => {}, ["stop"])),
                                        _withKeys(_withModifiers($setup.submitNewLink, ["exact","prevent"]), ["enter"])
                                      ],
                                      onKeyup: _cache[63] || (_cache[63] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[64] || (_cache[64] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_179), [
                                      [_vModelText, $setup.newLinkTitle]
                                    ]),
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => (($setup.newLinkNote) = $event)),
                                      class: "nge-cl-help-create-note",
                                      placeholder: "Optional note...",
                                      rows: "2",
                                      onKeydown: _cache[66] || (_cache[66] = _withModifiers(() => {}, ["stop"])),
                                      onKeyup: _cache[67] || (_cache[67] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[68] || (_cache[68] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                      [_vModelText, $setup.newLinkNote]
                                    ]),
                                    _createElementVNode("label", _hoisted_180, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => (($setup.newLinkPublic) = $event))
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_vModelCheckbox, $setup.newLinkPublic]
                                      ]),
                                      _createTextVNode(" Make public (anyone in the lab can see) ")
                                    ]),
                                    _createElementVNode("div", _hoisted_181, [
                                      _createElementVNode("button", {
                                        class: "nge-cl-help-create-submit",
                                        onClick: $setup.submitNewLink
                                      }, "💾 Save Link"),
                                      _createElementVNode("button", {
                                        class: "nge-cl-help-create-cancel",
                                        onClick: _cache[70] || (_cache[70] = $event => ($setup.showSaveLinkForm = false))
                                      }, "Cancel")
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createCommentVNode(" Ownership filter chips + Save new "),
                          _createElementVNode("div", _hoisted_182, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nge-cl-link-save-new", { active: $setup.showSaveLinkForm }]),
                              onClick: _cache[71] || (_cache[71] = $event => ($setup.showSaveLinkForm = !$setup.showSaveLinkForm)),
                              title: "Save the current view as a working link"
                            }, "+ Save new", 2 /* CLASS */),
                            _hoisted_183,
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: $setup.linksOwnershipFilter === 'all' }),
                              onClick: _cache[72] || (_cache[72] = $event => ($setup.linksOwnershipFilter = 'all'))
                            }, "All", 2 /* CLASS */),
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: $setup.linksOwnershipFilter === 'mine' }),
                              onClick: _cache[73] || (_cache[73] = $event => ($setup.linksOwnershipFilter = 'mine'))
                            }, "Mine", 2 /* CLASS */),
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: $setup.linksOwnershipFilter === 'shared' }),
                              onClick: _cache[74] || (_cache[74] = $event => ($setup.linksOwnershipFilter = 'shared'))
                            }, "Shared", 2 /* CLASS */)
                          ]),
                          _createCommentVNode(" Empty state "),
                          ($setup.visibleLinks.length === 0 && !$setup.showSaveLinkForm)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                _createTextVNode(" No saved links yet. Click "),
                                _hoisted_185,
                                _createTextVNode(" above to save the current view. ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" Link rows "),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleLinks, (link) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: link.id,
                              class: _normalizeClass(["nge-cl-help-item nge-cl-link-item", { 'nge-cl-link-item--starred': link.starred }])
                            }, [
                              _createElementVNode("div", _hoisted_186, [
                                _createElementVNode("div", _hoisted_187, [
                                  _createElementVNode("span", {
                                    class: "nge-cl-pip",
                                    style: _normalizeStyle({ background: link.starred ? '#f5d142' : '#557' })
                                  }, null, 4 /* STYLE */),
                                  _createElementVNode("div", _hoisted_188, [
                                    ($setup.renamingLinkId === link.id)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => (($setup.renamingLinkValue) = $event)),
                                            class: "nge-cl-search-input",
                                            onKeydown: [
                                              _cache[76] || (_cache[76] = _withModifiers(() => {}, ["stop"])),
                                              _withKeys(_withModifiers($event => ($setup.commitRename(link)), ["exact","prevent"]), ["enter"])
                                            ],
                                            onKeyup: _cache[77] || (_cache[77] = _withModifiers(() => {}, ["stop"])),
                                            onKeypress: _cache[78] || (_cache[78] = _withModifiers(() => {}, ["stop"])),
                                            onBlur: $event => ($setup.commitRename(link)),
                                            ref_for: true,
                                            ref: "renameInput",
                                            autofocus: ""
                                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_190), [
                                            [_vModelText, $setup.renamingLinkValue]
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "nge-cl-row-name nge-cl-link-title",
                                          onDblclick: $event => ($setup.startRename(link)),
                                          title: 'Double-click to rename · ' + link.title
                                        }, _toDisplayString(link.title), 41 /* TEXT, PROPS, HYDRATE_EVENTS */, _hoisted_191)),
                                    _createElementVNode("div", _hoisted_192, [
                                      (link.dataset)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "nge-cl-badge",
                                            style: _normalizeStyle({ background: 'rgba(120,140,255,0.12)', color: '#abf' })
                                          }, _toDisplayString(link.dataset), 5 /* TEXT, STYLE */))
                                        : _createCommentVNode("v-if", true),
                                      (link.userId !== $setup.backend.userId && link.userName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_193, "by " + _toDisplayString(link.userName), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      (link.isPublic)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_194, "🌐 public"))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("span", _hoisted_195, _toDisplayString($setup.relativeTimeShort(link.createdAt)), 1 /* TEXT */)
                                    ]),
                                    (link.note)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString(link.note), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_197, [
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn nge-cl-btn--jump",
                                    onClick: $event => ($setup.openLink(link)),
                                    title: "Open link in viewer"
                                  }, "↗", 8 /* PROPS */, _hoisted_198),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn",
                                    onClick: $event => ($setup.linksStore.toggleStar(link.id)),
                                    title: link.starred ? 'Unstar' : 'Star'
                                  }, _toDisplayString(link.starred ? '★' : '☆'), 9 /* TEXT, PROPS */, _hoisted_199),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn",
                                    onClick: $event => ($setup.startRename(link)),
                                    title: "Rename"
                                  }, "✏️", 8 /* PROPS */, _hoisted_200),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn",
                                    onClick: $event => ($setup.shareLinkToChat(link)),
                                    title: "Share to chat"
                                  }, "💬", 8 /* PROPS */, _hoisted_201),
                                  (link.userId === $setup.backend.userId)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "nge-cl-btn nge-cl-btn--release",
                                        onClick: $event => ($setup.linksStore.remove(link.id)),
                                        title: "Delete"
                                      }, "×", 8 /* PROPS */, _hoisted_202))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ])
                            ], 2 /* CLASS */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    : ($setup.loading || $setup.backend.loading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                          _createCommentVNode(" ═══ CELL TABS ═══ "),
                          _createCommentVNode(" Loading "),
                          _hoisted_203
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                      : ($setup.cells.length === 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                            _createCommentVNode(" Empty state "),
                            _createElementVNode("div", _hoisted_204, [
                              _hoisted_205,
                              (!$setup.queue.sheetUrl)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_206, "Open Brain Quest first and load a quest sheet."))
                                : _createCommentVNode("v-if", true)
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                            _createCommentVNode(" Cell list "),
                            _createElementVNode("div", _hoisted_207, [
                              _createCommentVNode(" Claim error banner "),
                              ($setup.claimError)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "nge-cl-error-banner",
                                    onClick: _cache[79] || (_cache[79] = $event => ($setup.claimError = ''))
                                  }, [
                                    _createTextVNode(_toDisplayString($setup.claimError) + " ", 1 /* TEXT */),
                                    _hoisted_208
                                  ]))
                                : _createCommentVNode("v-if", true),
                              ($setup.filteredCells.length === 0 && $setup.filter === 'mine')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_209, " No claimed cells yet. Claim cells from the All or Available tabs! "))
                                : ($setup.filteredCells.length === 0 && $setup.filter === 'available' && !$setup.search.trim())
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                      _createTextVNode(" No available cells in "),
                                      _createElementVNode("strong", null, _toDisplayString($setup.currentDatasetLabel), 1 /* TEXT */),
                                      _createTextVNode(". "),
                                      ($setup.suggestedClaimDataset)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _hoisted_211,
                                            _createTextVNode("Switch to "),
                                            _createElementVNode("strong", null, _toDisplayString($setup.suggestedClaimDataset), 1 /* TEXT */),
                                            _createTextVNode(" to claim a cell. ")
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  : ($setup.filteredCells.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_212, "No matching cells"))
                                    : _createCommentVNode("v-if", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCells, (cell) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: cell.segId,
                                  class: _normalizeClass(["nge-cl-row", {
              'nge-cl-row--done': cell.status === 'completed',
              'nge-cl-row--mine': $setup.isMyClaim(cell),
              'nge-cl-row--jumped': cell.segId === $setup.jumpedSegId,
            }])
                                }, [
                                  _createCommentVNode(" Left: status pip + name "),
                                  _createElementVNode("div", _hoisted_213, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["nge-cl-pip", $setup.statusClass(cell.status)])
                                    }, null, 2 /* CLASS */),
                                    _createElementVNode("div", _hoisted_214, [
                                      _createElementVNode("div", {
                                        class: "nge-cl-row-name",
                                        onClick: $event => ($setup.copyId(cell.segId)),
                                        title: 'Click to copy ' + cell.segId
                                      }, [
                                        _createTextVNode(_toDisplayString($setup.history.getNickname(cell.segId) || cell.segId) + " ", 1 /* TEXT */),
                                        ($setup.copiedId === cell.segId)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_216, "copied"))
                                          : _createCommentVNode("v-if", true)
                                      ], 8 /* PROPS */, _hoisted_215),
                                      _createElementVNode("div", _hoisted_217, [
                                        (cell.segId === $setup.jumpedSegId)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_218, "● viewing"))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["nge-cl-badge", $setup.statusClass(cell.status)])
                                        }, _toDisplayString($setup.statusLabel(cell.status)), 3 /* TEXT, CLASS */),
                                        (cell.assignedTo)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_219, _toDisplayString($setup.getCachedUserName(cell.assignedTo)), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        (cell.notes)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_220, _toDisplayString(cell.notes), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ])
                                  ]),
                                  _createCommentVNode(" Right: actions "),
                                  _createElementVNode("div", _hoisted_221, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["nge-cl-btn nge-cl-btn--jump", { 'nge-cl-btn--jump-active': cell.segId === $setup.jumpedSegId }]),
                                      onClick: $event => ($setup.jumpToCell(cell.segId, cell.nucCoords || cell.somaCoords)),
                                      title: cell.segId === $setup.jumpedSegId ? 'Currently viewing — jump again' : 'Jump to segment'
                                    }, "↗", 10 /* CLASS, PROPS */, _hoisted_222),
                                    (cell.status === 'pending' && $setup.isLoggedIn)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "nge-cl-btn nge-cl-btn--claim",
                                          onClick: $event => ($setup.claimCell(cell))
                                        }, "Claim", 8 /* PROPS */, _hoisted_223))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.isMyClaim(cell))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-btn nge-cl-btn--release",
                                          onClick: $event => ($setup.releaseCell(cell)),
                                          title: "Release claim"
                                        }, "Release", 8 /* PROPS */, _hoisted_224))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.isMyClaim(cell))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          class: "nge-cl-btn nge-cl-btn--complete",
                                          onClick: $event => ($setup.completeCell(cell))
                                        }, "Complete", 8 /* PROPS */, _hoisted_225))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ], 2 /* CLASS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
            _createCommentVNode(" Login prompt "),
            (!$setup.isLoggedIn && $setup.cells.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_226, " Log in to claim and complete cells "))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Resize handle (bottom-right corner) "),
            _createElementVNode("div", {
              class: "nge-cl-resize",
              onMousedown: $setup.startResize,
              title: "Drag to resize"
            }, _hoisted_228, 32 /* HYDRATE_EVENTS */)
          ], 4 /* STYLE */)
        ]),
        _: 1 /* STABLE */
      })
    ])),
    _createCommentVNode(" Cross-dataset jump confirmation modal "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.jumpConfirmReq)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-cl-jumpconfirm-backdrop",
            onClick: _withModifiers($setup.cancelJumpConfirm, ["self"])
          }, [
            _createElementVNode("div", _hoisted_230, [
              _hoisted_231,
              _createElementVNode("div", _hoisted_232, [
                _createTextVNode(" This help request is on "),
                _createElementVNode("strong", null, _toDisplayString($setup.jumpConfirmReq.dataset), 1 /* TEXT */),
                _createTextVNode(". You're currently viewing "),
                _createElementVNode("strong", null, _toDisplayString($setup.activeDataset || 'an unknown dataset'), 1 /* TEXT */),
                _createTextVNode(". The viewer will reload with new layers — copy your current state URL first if you don't want to lose your spot. ")
              ]),
              (!$setup.jumpConfirmTargetDs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_233, " ⚠ This dataset isn't in the known dataset list. We'll jump to the segment but won't auto-switch layers — you may need to load it manually. "))
                : (!$setup.jumpConfirmTargetServerHasAuth())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_234, " ⚠ You haven't logged into this dataset's server yet. You'll be prompted to log in after the switch. "))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_235, [
                _createElementVNode("input", {
                  class: "nge-cl-jumpconfirm-url",
                  value: $setup.getCurrentUrl(),
                  readonly: "",
                  onClick: $setup.selectInputContents,
                  title: "Click to select, then copy"
                }, null, 8 /* PROPS */, _hoisted_236),
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-copy",
                  onClick: $setup.copyJumpConfirmUrl
                }, _toDisplayString($setup.jumpConfirmCopied ? '✓ Copied' : '📋 Copy URL'), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_237, [
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-save",
                  onClick: $setup.saveCurrentAsLink,
                  disabled: !$setup.backend.userId
                }, " 💾 Save link before switching ", 8 /* PROPS */, _hoisted_238)
              ]),
              _createElementVNode("div", _hoisted_239, [
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-cancel",
                  onClick: $setup.cancelJumpConfirm
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-go",
                  onClick: $setup.confirmJump
                }, _toDisplayString($setup.jumpConfirmTargetDs ? 'Switch & Jump' : 'Jump anyway'), 1 /* TEXT */)
              ])
            ])
          ], 8 /* PROPS */, _hoisted_229))
        : _createCommentVNode("v-if", true)
    ])),
    _createCommentVNode(" Screenshot attach dialog for help requests "),
    _createVNode($setup["ScreenshotDialog"], {
      show: $setup.showHelpScreenshotDialog,
      mode: "attach",
      onClose: _cache[80] || (_cache[80] = $event => ($setup.showHelpScreenshotDialog = false)),
      onAttached: $setup.onHelpScreenshotAttached
    }, null, 8 /* PROPS */, ["show"]),
    _createVNode($setup["ScreenshotDialog"], {
      show: $setup.showResponseScreenshotDialog,
      mode: "attach",
      onClose: _cache[81] || (_cache[81] = $event => ($setup.showResponseScreenshotDialog = false)),
      onAttached: $setup.onResponseScreenshotAttached
    }, null, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}